import sectionQuestionFaqCss from '../css-snippets/section-question-faq';

const html = `
<style>${sectionQuestionFaqCss}</style>
    <div data-attribute="question-faq-container" style="--faq-accordion-border-color: #ebe6e2;" data-top-padding="true" data-bottom-padding="true">
        <div class="wrap-question-faq container">
            <div class="header-question-faq">
                <h2 data-attribute="title-question-faq" class="title-question-faq"><strong>Frequently Asked Questions</strong></h2>
            </div>
            <div class="body-question-faq">
                <div data-attribute="state-toggle" class="state-toggle">
                <input type="radio" name="accordion" id="close-all" class="close-all" checked="">
                </div>
                <div data-attribute="wrap-item-question-faq" class="wrap-item-question-faq">
                <div data-attribute="item-question-faq" class="item-question-faq accordion-item">
                    <input data-attribute="accordion-input" type="radio" name="accordion" id="accordion-unique-id-0" class="accordion-input">
                    <label data-attribute="accordion-header" for="accordion-unique-id-0" class="accordion-header">
                    <p data-attribute="accordion-title" class="accordion-title">1. Will the cover fit my car?</p>
                    <span class="accordion-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide-icon lucide lucide-chevron-down text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200">
                        <!---->
                        <path d="m6 9 6 6 6-6"></path>
                        <!----><!----><!---->
                        </svg>
                    </span>
                    <label for="close-all" class="close-btn"></label>
                    </label>
                    <div class="accordion-content">
                    <div data-attribute="accordion-content" class="accordion-text">
                        <p>
                        Yes! The bold Waterproof Dog Car Seat Cover with Hard Bottom is designed to fit most vehicles, including SUVs,
                        trucks, and sedans. It features adjustable straps and side flaps to accommodate various seat sizes, even
                        captain's chairs or split bench layouts.
                        </p>
                    </div>
                    </div>
                </div>
                <div data-attribute="item-question-faq" class="item-question-faq accordion-item">
                    <input data-attribute="accordion-input" type="radio" name="accordion" id="accordion-unique-id-1" class="accordion-input">
                    <label data-attribute="accordion-header" for="accordion-unique-id-1" class="accordion-header">
                    <p data-attribute="accordion-title" class="accordion-title">2. Is it really stable for large dogs?</p>
                    <span class="accordion-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide-icon lucide lucide-chevron-down text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200">
                        <!---->
                        <path d="m6 9 6 6 6-6"></path>
                        <!----><!----><!---->
                        </svg>
                    </span>
                    <label for="close-all" class="close-btn"></label>
                    </label>
                    <div class="accordion-content">
                    <div data-attribute="accordion-content" class="accordion-text">
                        <p><span style="color:rgb(18,18,18);">Absolutely. Unlike floppy hammocks, the bold Waterproof Dog Car Seat Cover with Hard Bottom features a reinforced solid base that prevents sagging and slipping. It turns the entire back seat into a flat, safe space for your pet.</span></p>
                    </div>
                    </div>
                </div>
                <div data-attribute="item-question-faq" class="item-question-faq accordion-item">
                    <input data-attribute="accordion-input" type="radio" name="accordion" id="accordion-unique-id-2" class="accordion-input">
                    <label data-attribute="accordion-header" for="accordion-unique-id-2" class="accordion-header">
                    <p data-attribute="accordion-title" class="accordion-title">3.  How easy is it to clean?</p>
                    <span class="accordion-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide-icon lucide lucide-chevron-down text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200">
                        <!---->
                        <path d="m6 9 6 6 6-6"></path>
                        <!----><!----><!---->
                        </svg>
                    </span>
                    <label for="close-all" class="close-btn"></label>
                    </label>
                    <div class="accordion-content">
                    <div data-attribute="accordion-content" class="accordion-text">
                        <p><span style="background-color:rgb(249,250,251);color:rgb(18,18,18);">Super easy! The bold Waterproof Dog Car Seat Cover with Hard Bottom is made with 4-layer waterproof Oxford fabric, so you can simply wipe it down, shake it off, or vacuum it. No more deep cleaning or constant washes after every trip.</span></p>
                    </div>
                    </div>
                </div>
                <div data-attribute="item-question-faq" class="item-question-faq accordion-item">
                    <input data-attribute="accordion-input" type="radio" name="accordion" id="accordion-unique-id-3" class="accordion-input">
                    <label data-attribute="accordion-header" for="accordion-unique-id-3" class="accordion-header">
                    <p data-attribute="accordion-title" class="accordion-title">4. Will my dog feel safe and comfortable?</p>
                    <span class="accordion-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide-icon lucide lucide-chevron-down text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200">
                        <!---->
                        <path d="m6 9 6 6 6-6"></path>
                        <!----><!----><!---->
                        </svg>
                    </span>
                    <label for="close-all" class="close-btn"></label>
                    </label>
                    <div class="accordion-content">
                    <div data-attribute="accordion-content" class="accordion-text">
                        <p><span style="background-color:rgb(249,250,251);color:rgb(18,18,18);">Yes. The bold Waterproof Dog Car Seat Cover with Hard Bottom includes a mesh visual window that allows pets to see you while driving. The solid base also gives dogs a sturdy surface to sit or lie down on comfortably.</span></p>
                    </div>
                    </div>
                </div>
                <div data-attribute="item-question-faq" class="item-question-faq accordion-item">
                    <input data-attribute="accordion-input" type="radio" name="accordion" id="accordion-unique-id-4" class="accordion-input">
                    <label data-attribute="accordion-header" for="accordion-unique-id-4" class="accordion-header">
                    <p data-attribute="accordion-title" class="accordion-title">5.  What if it doesn't work for me?</p>
                    <span class="accordion-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide-icon lucide lucide-chevron-down text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200">
                        <!---->
                        <path d="m6 9 6 6 6-6"></path>
                        <!----><!----><!---->
                        </svg>
                    </span>
                    <label for="close-all" class="close-btn"></label>
                    </label>
                    <div class="accordion-content">
                    <div data-attribute="accordion-content" class="accordion-text">
                        <p><span style="background-color:rgb(249,250,251);color:rgb(18,18,18);">We’ve got you. The bold Waterproof Dog Car Seat Cover with Hard Bottom comes with a risk-free satisfaction guarantee. If it doesn't meet your expectations, you can contact us for a hassle-free return or exchange within the return window.</span></p>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
`;
export default html;
